import { render } from "./ToolMenuItem.vue?vue&type=template&id=01ca516a&scoped=true"
import script from "./ToolMenuItem.vue?vue&type=script&lang=js"
export * from "./ToolMenuItem.vue?vue&type=script&lang=js"

import "./ToolMenuItem.vue?vue&type=style&index=0&id=01ca516a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ca516a"]])

export default __exports__